enum DateFormats {
  DATE = 'dd/MM/yyyy',
  TIME = 'HH:mm',
  DATE_WITH_TIME = 'dd/MM/yyyy HH:mm',
  DAY_WITH_SHORT_MONTH = 'd MMM',
  ISO_DATE = 'yyyy-MM-dd'
}

export default DateFormats
